export function normalizerGeneratorArray<Input, Output>(
  itemFn: (i?: Input | null) => Output | null
) {
  const fn = (array?: (Input | null)[] | null) => {
    if (!array || !Array.isArray(array)) {
      return []
    }

    return array.map(itemFn).filter((i) => i != null) as NonNullable<Output>[]
  }

  return fn
}
